import { Row, Col, Table, Form, Spinner } from "react-bootstrap"
import SelectedGovPanel from "../../api/Randoms/GovPoolModel/GovPerformCollection"
import { useCallback, useEffect, useState } from "react"
import MainPanelRow from "./MainPanelRow"
import { Dictionary } from "../../api/GovPerformCollection/Dictionary"
import { PanelResult } from "../../api/GovPerformCollection/PanelResult"

export interface MainPanels {
  panels: Dictionary<SelectedGovPanel>
  loading?: boolean
  onUpdate: (panels: Dictionary<SelectedGovPanel>) => void
}

const MainPanels = (props: MainPanels) => {
  const { loading = false, onUpdate } = props

  const [panels, setPanels] = useState<Dictionary<SelectedGovPanel>>(props.panels)

  const isAllPanelSelected = (type: number) => Object.values(panels)
    .filter(panel => panel.ExternalID !== "")
    .every(panel => panel.SelectedStatus === type)

  const isAllPanelDisabled = () => loading || Object.values(panels).filter(panel => panel.ExternalID !== "").length == 0

  const isAllSendToLabSelected = () => {
    const values = Object.values(panels).filter(panel => panel.ExternalID !== "")
    return values.length == 0 || values.every(panel => panel.SendToLab === 1)
  }

  const isAllSendToLabDisabled = () => Object.values(panels)
    .filter(panel => panel.ExternalID !== "")
    .every(panel => panel.SelectedStatus === PanelResult.NOT_SELECTED)

  const onSelectAllPanels = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value)
    const uncheckLabOnNegative = (isAllPanelSelected(PanelResult.POSITIVE) || isAllPanelSelected(PanelResult.INCONCLUSIVE)) && value == PanelResult.NEGATIVE
    const selectedPanels = Object.entries(panels)
      .reduce<Dictionary<SelectedGovPanel>>((acc, [key, panel]) => {
        return {
          ...acc,
          [key]: {
            ...panel,
            SelectedStatus: panel.ExternalID !== "" ? value : panel.SelectedStatus,
            SendToLab: [PanelResult.POSITIVE, PanelResult.INCONCLUSIVE].includes(value) && panel.ExternalID !== "" ? 1 : uncheckLabOnNegative ? 0 : panel.SendToLab
          }
        }
      }, {})

    setPanels(prev => ({ ...prev, ...selectedPanels }))
  }

  const onSelectAllSendToLab = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked ? 1 : 0

    const selectedPanels = Object.entries(panels)
      .reduce((acc, [key, panel]) => {
        return {
          ...acc,
          [key]: {
            ...panel,
            SendToLab: panel.SelectedStatus !== PanelResult.NOT_SELECTED && panel.ExternalID !== "" ? checked : panel.SendToLab
          }
        }
      }, {})

    setPanels(prev => ({ ...prev, ...selectedPanels }))
  }

  const onUpdatePanel = useCallback((panel: SelectedGovPanel) => {
    setPanels(prev => ({ ...prev, [panel.InternalCode]: { ...prev[panel.InternalCode], ...panel } }))
  }, [])

  useEffect(() => {
    setPanels(props.panels)
  }, [props.panels])

  useEffect(() => {
    onUpdate(panels)
  }, [onUpdate, panels])

  return (
    <Row className="pt-2">
      <Col>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>DRUG CODE</th>
              <th>
                <Form.Check inline name="panel_header" type="radio" className="with-label"
                  id="ph_positive"
                  label="POSITIVE"
                  value={PanelResult.POSITIVE}
                  disabled={isAllPanelDisabled()}
                  checked={isAllPanelSelected(PanelResult.POSITIVE)}
                  onChange={onSelectAllPanels} />
              </th>
              <th>
                <Form.Check inline name="panel_header" type="radio" className="with-label"
                  id="ph_inconclusive"
                  label="INCONCLUSIVE"
                  value={PanelResult.INCONCLUSIVE}
                  disabled={isAllPanelDisabled()}
                  checked={isAllPanelSelected(PanelResult.INCONCLUSIVE)}
                  onChange={onSelectAllPanels} />
              </th>
              <th>
                <Form.Check inline name="panel_header" type="radio" className="with-label"
                  id="ph_negative"
                  label="NEGATIVE"
                  value={PanelResult.NEGATIVE}
                  disabled={isAllPanelDisabled()}
                  checked={isAllPanelSelected(PanelResult.NEGATIVE)}
                  onChange={onSelectAllPanels} />
              </th>
              <th>
                <Form.Check inline type="checkbox" className="with-label"
                  id="ph_send_to_lab"
                  label="SEND TO LAB"
                  checked={isAllSendToLabSelected()}
                  disabled={isAllSendToLabDisabled()}
                  onChange={onSelectAllSendToLab} />
              </th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5}><Spinner animation="border" variant="light" /></td></tr>}
            {!loading && Object.values(panels).length == 0 && <tr><td colSpan={5}>DATA NOT FOUND</td></tr>}
            {!loading && Object.values(panels).map((panel) =>
              <MainPanelRow key={`panel_row_${panel.InternalCode}`} panel={panel} onUpdatePanel={onUpdatePanel} />
            )}
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

export default MainPanels
